import React, {useState, useEffect} from 'react'
import {connect} from "react-redux";
import {STORE_STATE} from "../../redux/store";
import {get} from "lodash";
import {ArticleActions} from "../../redux/articles";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import translate from "../reusable/translate";
import SecondaryButton from "../materialCommitment/buttons/SecondaryButton";
import PrimaryButton from "../materialCommitment/buttons/PrimaryButton";
import moment from 'moment'

const MyCommitmentsListing = ({
                                  userCommitments,
                                  commitmentsForOrganizations,
                                  organizations,
                                  userId,
                                  getCommitmentsForOrganizationById,
                                  getUserCommitments
}) => {

    useEffect(() => {
        if(userId){
            getUserCommitments(userId)
            getCommitmentsForOrganizationById(organizations
                .map(org => org.organizationId))
        }
    }, [])

    const userApprovedCommitments = userCommitments
        .filter(commitment => commitment.status === 'approved');

    const userDraftCommitments = userCommitments
        .filter(commitment => commitment.status === 'draft');

    return(
        <div className="container margin-top">
            <PersonalCommitmentsListing
                userCommitments={userCommitments}
                userApprovedCommitments={userApprovedCommitments}
                userDraftCommitments={userDraftCommitments}
            />

            <OrganizationCommitmentsListing
                organizations={organizations}
                commitmentsForOrganizations={commitmentsForOrganizations}
            />
        </div>
    )
};

const PersonalCommitmentsListing = ({userCommitments ,userApprovedCommitments, userDraftCommitments}) => {
    return(
        <div>
            <h1 className="border-bottom-thin">{translate({textKey: "sit.profile.personalCommitments"})}</h1>
            <div>

                <ApprovedValidCommitments approvedCommitments={userApprovedCommitments}/>
                <ApprovedOldCommitments approvedCommitments={userApprovedCommitments}/>

                {!!userDraftCommitments.length &&
                <HeaderWithBorderBot
                    textKey={"sit.profile.draftCommitments"}
                />}

                {userDraftCommitments.map(commitment =>
                    <CommitmentDisplay
                        key={commitment.id}
                        commitment={commitment}
                    />
                )}

                {!userCommitments.length &&
                <div className="flex-row items-center space-between">
                    <p className="p">{translate({textKey: "sit.commitmentList.noCommitments"})}</p>
                    <button
                        className="green-button"
                        onClick={() => window.location.href = "/web/sitoumus2050/elamantavat#/"}
                    >
                        {translate({textKey: "sit.commitmentList.lifestyleAndCommitment"})}
                    </button>
                </div>}
            </div>
        </div>
    )
};

const OrganizationCommitmentsListing = ({organizations, commitmentsForOrganizations}) => {

    return(
        <div>
            <h1 className="border-bottom-thin">{translate({textKey: "sit.profile.organizationCommitments"})}</h1>
            {organizations.map(org =>
                <OrganizationCommitmentDisplay
                    key={org.organizationId}
                    organization={org}
                    commitmentForOrganizations={commitmentsForOrganizations}
                />)}
        </div>
    )
}

const OrganizationCommitmentDisplay = ({organization, commitmentForOrganizations}) => {

    const commitments = Object.keys(commitmentForOrganizations)
        .filter(key => Number(key) === Number(organization.organizationId))
        .reduce((obj, key) => {
            obj = commitmentForOrganizations[key]
            return obj;
    }, []);

    const approvedCommitments = commitments
        .filter(commitment => commitment.status === 'approved');
    const draftCommitments = commitments
        .filter(commitment => commitment.status === 'draft');




    return(
        <div>
            {!!(draftCommitments.length + approvedCommitments.length) &&
            <h2>{translate({textKey: "sit.profile.organization"})}: <em>{organization.name}</em></h2>}

            <ApprovedValidCommitments approvedCommitments={approvedCommitments}/>
            <ApprovedOldCommitments approvedCommitments={approvedCommitments}/>

            {!!draftCommitments.length &&
            <HeaderWithBorderBot textKey={"sit.profile.draftCommitments"}/>}
            {draftCommitments.map(commitment =>
                <CommitmentDisplay key={commitment.id} commitment={commitment}/>
            )}
        </div>
    )
};

const CommitmentDisplay = ({commitment}) => {

    return(
        <div className="commitment-display-container border-bottom-thin">
            <div className="flex-row items-center space-evenly">
                <div className="flex-column w300">
                    <h4><b>{commitment.title_fi_FI}</b></h4>
                    <SocialIcons
                        joined={commitment.joined}
                        likes={commitment.likes}
                    />
                </div>
                <LinkToReporting commitment={commitment}/>
                <LinkToEditing commitment={commitment}/>
                <LinkToEditReporting commitment={commitment}/>
            </div>
        </div>
    )
};

const SocialIcons = ({joined, likes}) => {
    return(
        <div className="flex-row items-center">
            <i className="fas fa-share-alt"/>
            <p className="p">{joined}</p>
            <i className="fas fa-heart"/>
            <p className="p">{likes}</p>
        </div>
    )
};

const HeaderWithBorderBot = ({ textKey }) => {
    return(
        <h3 className="border-bottom-thin">
            {translate({textKey: textKey})}
        </h3>
    )
}

const ApprovedValidCommitments = ({ approvedCommitments }) => {

    const validApproved = approvedCommitments
        .filter(commitment => moment(commitment.endDate) >= moment(Date.now()))

    if (!validApproved.length) return null

    return(
        <div>
            <HeaderWithBorderBot textKey={"sit.profile.validCommitments"}/>
            {validApproved.map(commitment =>
                <CommitmentDisplay
                    key={commitment.id}
                    commitment={commitment}
                />)}
        </div>
    )
}

const ApprovedOldCommitments = ( {approvedCommitments }) => {
    const oldApproved = approvedCommitments
        .filter(commitment => moment(commitment.endDate) < moment(Date.now()))

    if (!oldApproved.length) return null

    return(
        <div>
            <HeaderWithBorderBot textKey={"sit.commitmentList.inactive"}/>
            {oldApproved.map(commitment =>
                <CommitmentDisplay
                    key={commitment.id}
                    commitment={commitment}
                />)}
        </div>
    )
}

const LinkToReporting = ({commitment}) => {
    return(
        <div>
            <Link to={{
                pathname: "/raportoi",
                state: {
                    commitment
                },
                search: `?commitmentId=${commitment.id}`
            }}>
                <PrimaryButton textKey={"sit.report"}/>
            </Link>
        </div>
    )
};

const LinkToEditing = ({commitment}) => {
    return(
        <div>
            <Link
                to={{
                    pathname: "/muokkaa-sitoumusta",
                    state: {
                        commitment
                    },
                    search: `?commitmentId=${
                        commitment.id
                    }&creatorOrganizationId=${
                        commitment.organizationId ? commitment.organizationId : ""
                    }`
                }}
            >
                <SecondaryButton textKey={"sit.edit"}/>
            </Link>
        </div>
    )
};

const LinkToEditReporting = ({commitment}) => {
    return(
        <div>
            <Link
                to={{
                    pathname: "/muokkaa-raporttia",
                    state: {
                        commitment
                    },
                    search: `?commitmentId=${commitment.id}&editing=true`
                }}
            >
                <button className="green-button">Muokkaa raportteja</button>
            </Link>
        </div>
    )
}

export default withRouter(
    connect(
        (state: STORE_STATE) => ({
            userCommitments: state.articles.userCommitments,
            commitmentsForOrganizations: state.articles.commitmentsForOrganizations,
            organizations: state.organizations.organizations,
            userId: get(state.user, "profile.userId"),
            locale: state.user.locale
        }),
        {
            getCommitmentsForOrganizationById:
            ArticleActions.getCommitmentsForOrganizationById,
            getUserCommitments: ArticleActions.getUserCommitments
        }
    )(MyCommitmentsListing)
);


// WEBPACK FOOTER //
// ./src/components/profile/MyCommitmentsListing.js